// File: Componates/RoomCheckOutTable.jsx
import React, { useState } from "react";
import PropTypes from "prop-types";
import {
  AdvanceDetailsRules
} from "validation/ValidationRules";

import FormSubmitButton from "Common/Custom/FormSubmitButton";
import PageBody from "Common/Custom/PageBody";
import { HeadingOne } from "Common/Custom/HeadingOne";

import GuestInfoSection from "./GuestInfoSection";
import RoomsSection from "./RoomsSection";
import ParkingSection from "./ParkingSection";
import BillingSummarySection from "./BillingSummarySection";
import AdvanceDetailsList from "./AdvanceDetailsList"
import CheckOutPrintInvoice from "./CheckOutPrintInvoice";
import { validateField } from "utils/validation";

import tableConfig from "../json/RoomCheckOutFields.json";

const RoomCheckOutTable = ({
  handleSubmit,
  loading,
  RoomCkeckOutDetail,
  paymentMethodTypesOption,
  values,
  setValues,
  setErrors,
  errors,
  Advance_Details,
  emptyPaymentDetail,
  dueAmount = 0,
  creditAmount = 0,
  id
}) => {
  const [settlements, setSettlements] = useState([]);

  const handlePrint = () => window.print();

  if (!RoomCkeckOutDetail) return null;

  return (
    <>
      {/* ---------------- ON-SCREEN VIEW (hidden while printing) ---------------- */}
      <div className="d-print-none">
        <PageBody
          onSubmit={handleSubmit}
          rowClass="row g-3 row-deck"
          headerchildren={
            <>
              <HeadingOne>Checkout – {RoomCkeckOutDetail.booking_number}</HeadingOne>
              <button
                type="button"
                className="btn btn-outline-secondary btn-sm"
                onClick={handlePrint}
              >
                <i className="bi bi-printer me-1" />
                Print Invoice
              </button>
            </>
          }
        >
          <GuestInfoSection data={RoomCkeckOutDetail} config={tableConfig.guestInfo} />

          <RoomsSection
            rooms={RoomCkeckOutDetail.rooms}
            columns={tableConfig.roomColumns}
            grandTotal={RoomCkeckOutDetail.rooms_total}
          />

          {RoomCkeckOutDetail.parking_detail && (
            <ParkingSection
              data={RoomCkeckOutDetail}
              config={tableConfig.parkingSummary}
            />
          )}

          <BillingSummarySection
            data={RoomCkeckOutDetail.billing_detail}
            config={tableConfig.billingSummary}
            RoomCkeckOutDetail={RoomCkeckOutDetail}
          />

          <AdvanceDetailsList
            Advance_Details={Advance_Details}
            paymentMethodTypesOption={paymentMethodTypesOption}
            values={values}
            setValues={setValues}
            errors={errors}
            setErrors={setErrors}
            emptyPaymentDetail={emptyPaymentDetail}
            validateField={validateField}
            AdvanceDetailsRules={AdvanceDetailsRules}
            dueAmount={dueAmount}
            creditAmount={creditAmount}
          />



          <FormSubmitButton
            label="Confirm Checkout"
            loading={loading}
            colSize="col-12"
            align="end"
          />
        </PageBody>
      </div>

      {/* ---------------- PRINT-ONLY VIEW ---------------- */}
      <div className="d-none d-print-block print-invoice-wrapper">
        <CheckOutPrintInvoice id={id} />
      </div>
    </>
  );
};

RoomCheckOutTable.propTypes = {
  handleSubmit: PropTypes.func.isRequired,
  loading: PropTypes.bool,
  RoomCkeckOutDetail: PropTypes.object,
  paymentMethodTypesOption: PropTypes.array,
  dueAmount: PropTypes.number
};

export default RoomCheckOutTable;